import API from './api';

export default class SearchKeyApi {
  static create(params) {
    return API.post('/search_keys', params);
  }
}
